import { defineComponent as _defineComponent } from 'vue'
import { useToast } from './useToast';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppToast',
  setup(__props) {

const { toasts } = useToast();

return { __sfc: true,toasts }
}

})